import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CardConfirma',
  props: {
	title: { type: String, default: 'Confirma' },
	carregando: { type: Boolean, default: false },
},
  emits: ["cancel", "confirm"],
  setup(__props) {





return { __sfc: true, }
}

})